import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';

import { getTabs } from '../utils/tabs';
import { Page } from '../../../../../shared/ui/Page';
import { useReadBotQuery } from '../service/bot';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';

const pageSlug = 'bot-setting-page';

export const BotSettingPage = () => {
    const current = useAppSelector(selectShopCurrent);
    const navigate = useNavigate();

    const [tab, setTab] = useState<string>(
        sessionStorage.getItem(pageSlug) || 'main'
    );

    const { data } = useReadBotQuery(current.id);

    useEffect(() => {
        navigate(tab, { replace: true });
        sessionStorage.setItem(pageSlug, tab);
    }, [tab]);

    const isDisabled = data === undefined;

    return (
        <Page isBackButton title={'Настройка бота'}>
            <Tabs
                activeKey={tab}
                onChange={setTab}
                items={getTabs(isDisabled)}
            />
            <Outlet />
        </Page>
    );
};
